import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=21727859&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21727859",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21727859')) {
      api.createRecord('21727859', component.options)
    } else {
      api.reload('21727859', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=21727859&scoped=true&", function () {
      api.rerender('21727859', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ATzGPgxILAMD/JS/comp/SearchFilterTokens.vue"
export default component.exports